import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const GoogleSignInButton = ({ containerId = 'google-signin-visible', options = {}, className }) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const { renderGoogleButton } = useAuth();

  // Measure container width and observe resize so button width matches screen
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    const updateWidth = () => {
      const w = el.clientWidth;
      if (w > 0) setContainerWidth(w);
    };
    updateWidth();
    const observer = new ResizeObserver(updateWidth);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  // Render Google button with width matching container; re-render when width changes
  useEffect(() => {
    const el = document.getElementById(containerId);
    if (!el || containerWidth <= 0) return;

    el.innerHTML = '';
    const width = Math.min(Math.max(containerWidth, 40), 400);
    renderGoogleButton(containerId, { ...options, width });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options intentionally excluded to avoid re-render loops
  }, [containerId, containerWidth, renderGoogleButton]);

  return (
    <div
      id={containerId}
      ref={containerRef}
      className={className}
      style={{ minHeight: 40 }}
    />
  );
};

export default GoogleSignInButton;
